import { v4 as uuidv4 } from 'uuid'

export const generateUuid = () => {
    const uuid = uuidv4().replace(/\-/g, '')
    return uuid.slice(0, 22) // shorten to 22 characters
}
